import deleteImg from './deleteIcon.svg'
import editImg from './editIcon.svg'
import rightArrowImg from './rightArrowIcon.svg';

export const deleteIcon = deleteImg;
export const editIcon = editImg;
export const rightArrowIcon = rightArrowImg;